<template>
    <div class="asset-allocation-table">
        <b-table
            small
            :selectable="true"
            :fields="columnNames"
            :items="rows"
            :hover="true"
            :tbody-tr-class="rowClass"
            select-mode="single"
            responsive="sm"
            thead-class="d-none"
            ref="assetAllocationTable"
            @row-selected="handleRowSelected">
            <!-- color -->
            <template v-slot:cell(colorClass)="data">
                <div
                    class="asset-allocation-table__color"
                    :class="data.value" />
            </template>

            <!-- icon -->
            <template v-slot:cell(icon)="data">
                <div class="asset-allocation-table__icon">
                    <Icon
                        :type="data.value"
                        :width="viewportIsLarge ? 26 : 21"
                        :height="viewportIsLarge ? 26 : 21" />
                </div>
            </template>

            <!-- percentage -->
            <template v-slot:cell(percentage)="data">
                <div class="asset-allocation-table__percentage">
                    {{ formatPercentage(data.value) }}%
                </div>
            </template>

            <!-- name -->
            <template v-slot:cell(name)="data">
                {{ data.value }}
            </template>
        </b-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ModelPortfolioAssetAllocationTable',
    data () {
        return {
            columnNames: [
                'colorClass',
                'icon',
                'percentage',
                'name',
            ],
        };
    },
    computed: {
        ...mapGetters(['viewportIsLarge']),
    },
    props: {
        selectedSubFilterType: {
            type: String,
            required: true,
        },
        rows: {
            type: Array,
            required: true,
        },
    },
    methods: {
        rowClass () {
            return 'asset-allocation-table__row';
        },
        handleRowSelected (selectedRows) {
            if (selectedRows[0]) { this.$emit('onChangeSubFilter', selectedRows[0]); }
        },
        formatPercentage (percentage) {
            return percentage.toFixed(2);
        },
        getIndexOfSubFilterType (subFilterType) {
            return this.rows.findIndex(row => row.detailsSubFilterType === subFilterType);
        },
    },
    watch: {
        selectedSubFilterType (val) {
            this.$refs.assetAllocationTable.selectRow(this.getIndexOfSubFilterType(val));
        },
    },
    mounted () {
    // set the default selection
        this.$refs.assetAllocationTable.selectRow(this.getIndexOfSubFilterType(this.selectedSubFilterType));
    },
    updated () {
    // set the default selection when switching between tabs
        this.$refs.assetAllocationTable.selectRow(this.getIndexOfSubFilterType(this.selectedSubFilterType));
    },
};
</script>

<style scoped lang="scss">
  $color-details-highlight: $mb-grey2;
  $size-color-box: 16px;
  $table-cell-padding-left-lg: 60px;
  $table-cell-padding-left-xs: 15px;

  .asset-allocation-table {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: $mb-grey1;

    ::v-deep tr:last-child {
      border-bottom: 1px solid $mb-grey5;
    }
  }

  .asset-allocation-table__icon .icon {
    vertical-align: middle;
  }

  .asset-allocation-table__color {
    width: $size-color-box;
    height: $size-color-box;
  }

  .asset-allocation-table__percentage {
    text-align: center;

    @include media-breakpoint-down(xs) {
      text-align: right;
    }
  }

  ::v-deep .b-table-row-selected {
    font-weight: bold;
    outline: none;
  }

  ::v-deep .asset-allocation-table__row {
    height: 36px;

    @include media-breakpoint-down(xs) {
      height: 32px;
    }

    &:hover {
      background-color: $mb-grey2;
    }

    td {
      padding-left: $table-cell-padding-left-lg;
      vertical-align: middle;

      @include media-breakpoint-down(xs) {
        padding-left: $table-cell-padding-left-xs;
      }

      &:nth-child(1) {
        width: 1%;
        @include media-breakpoint-down(xs) {
          display: none;
        }
      }

      &:nth-child(2) {
        width: 1%;
      }

      &:nth-child(3) {
        width: 1%;
      }
    }
  }
</style>
